import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-navy-deep text-primary-foreground/80">
      {/* Main grid: brand + 3 pillar columns */}
      <div className="border-b border-primary-foreground/10">
        <div className="container py-10 grid gap-8 md:grid-cols-5">
          <div>
            <p className="text-sm italic text-primary-foreground/85 font-semibold tracking-wide mb-2">
              Pharmalify Spine — connected GxP operations.
            </p>
            <p className="text-xs text-primary-foreground/55 leading-relaxed">
               One backbone for Quality (eQMS), QC Lab (LIMS) and Asset Integrity (CMMS), with native AI Agents and Regulatory Watch.
            </p>
          </div>

          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.12em] text-primary-foreground mb-3">Product</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/spine" className="text-primary-foreground/70 hover:text-accent transition-colors">Pharmalify Spine</Link></li>
              <li><Link to="/platform" className="text-primary-foreground/70 hover:text-accent transition-colors">Platform architecture</Link></li>
              <li><Link to="/ai-agents" className="text-primary-foreground/70 hover:text-accent transition-colors">AI Governance</Link></li>
              <li><Link to="/regulatory-hub" className="text-primary-foreground/70 hover:text-accent transition-colors">Regulatory Watch</Link></li>
              <li><Link to="/licensing" className="text-primary-foreground/70 hover:text-accent transition-colors">Licensing &amp; Validation</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.12em] text-primary-foreground mb-3">Solutions</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/solutions" className="text-primary-foreground/70 hover:text-accent transition-colors">By organization</Link></li>
              <li><Link to="/solutions/deviation-management-software" className="text-primary-foreground/70 hover:text-accent transition-colors">Deviation Management</Link></li>
              <li><Link to="/solutions/laboratory-investigations-oos-software" className="text-primary-foreground/70 hover:text-accent transition-colors">OOS/OOT Investigations</Link></li>
              <li><Link to="/solutions/supplier-qualification-software" className="text-primary-foreground/70 hover:text-accent transition-colors">Supplier Qualification</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.12em] text-primary-foreground mb-3">Trust</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/security-compliance" className="text-primary-foreground/70 hover:text-accent transition-colors">Trust &amp; Validation</Link></li>
              <li><Link to="/status" className="text-primary-foreground/70 hover:text-accent transition-colors">System Status</Link></li>
              <li><Link to="/changelog" className="text-primary-foreground/70 hover:text-accent transition-colors">Changelog</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[11px] font-bold uppercase tracking-[0.12em] text-primary-foreground mb-3">Company</h4>
            <ul className="space-y-2 text-xs">
              <li><Link to="/about" className="text-primary-foreground/70 hover:text-accent transition-colors">About</Link></li>
              <li><Link to="/contact" className="text-primary-foreground/70 hover:text-accent transition-colors">Request Walkthrough</Link></li>
              <li><Link to="/terms" className="text-primary-foreground/70 hover:text-accent transition-colors">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-primary-foreground/70 hover:text-accent transition-colors">Privacy Policy</Link></li>
            </ul>
          </div>
        </div>
      </div>

      <div>
        <div className="container py-3 text-center">
          <p className="text-[11px] text-primary-foreground/60 tracking-wide">
            © {new Date().getFullYear()} Pharmalify. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
